// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---h2T2c","centered":"centered---DV7j3","submitButton":"submitButton---ttmzl"};